import { withSanitiseFilterIdValue } from '@sbv-clients/domain-ui-shared';
import { Box, Typography, theme } from '@sbv-clients/ui-shared';

import Arrivals from './arrival-departures/arrivals';
import Departures from './arrival-departures/departures';
import { useContextFn } from './context/page';
import HppdWeeklyReport from './hppd-weekly-report';
import OverUnderUtilizationTable from './over-under-utilization/over-under-utilization-table';
import ShiftsStatus from './shifts-status';

const Main = () => {
  const context = useContextFn();
  const { startDate, endDate } = useContextFn();

  const departmentId = withSanitiseFilterIdValue(
    context.departmentId
  ) as number;
  const positionId = withSanitiseFilterIdValue(context.positionId) as number;

  return (
    <Box p={4}>
      <Box
        display="grid"
        gap={4}
        gridTemplateColumns={{
          xs: '1fr',
          lg: 'auto 1fr',
        }}
      >
        <ShiftsStatus
          positionId={positionId}
          departmentId={departmentId}
          startDate={startDate}
          endDate={endDate}
        />
        <Box
          display="grid"
          gap={4}
          gridTemplateColumns={{
            xs: 'minmax(0, 1fr)',
            md: 'minmax(0, 1fr) minmax(0, 1fr)',
          }}
        >
          <Arrivals
            departmentId={departmentId}
            positionId={positionId}
            startDate={startDate}
          />
          <Departures
            departmentId={departmentId}
            positionId={positionId}
            startDate={startDate}
          />
        </Box>
      </Box>

      <Box display="flex" alignItems="center" flexDirection="column">
        <Typography variant="h3" my={3}>
          Over Under
        </Typography>
        <OverUnderUtilizationTable
          positionId={positionId}
          startDate={startDate}
        />
      </Box>
      <Box mt={5}>
        <Typography
          variant="subtitle1"
          my={2}
          color={theme.text.sectionSubtitle}
        >
          PBJ HPPD Current Week Report
        </Typography>
        <HppdWeeklyReport
          departmentId={departmentId}
          startDate={startDate}
          positionId={positionId}
        />
      </Box>
    </Box>
  );
};

export default Main;
